import { formatAuditFieldChanges } from '@/common/FormattingUtils';
import { BvTableFieldArray } from 'bootstrap-vue';

export const feedProductAuditFields: BvTableFieldArray = [
	{ key: 'created_at', label: 'Date Sent' },
	{ key: 'from', label: 'From', formatter: formatAuditFieldChanges },
	{ key: 'to', label: 'To', formatter: formatAuditFieldChanges },
	{ key: 'user.name', label: 'By' },
];

export const feedProductSubscriptionAuditFields: BvTableFieldArray = [
	{ key: 'created_at', label: 'Date Sent' },
	{ key: 'event', label: 'Event' },
	{ key: 'from', label: 'From' },
	{ key: 'to', label: 'To' },
	{ key: 'user.name', label: 'By' },
];
